<template>
  <el-dialog
    class="afterSales"
    title="申请售后"
    :visible.sync="afterSalesVisible"
    width="862px"
    :before-close="handleClose"
  >
    <span>请选择需要售后的商品</span>
    <el-table v-loading="loading" :data="afterList" style="width: 100%">
      <el-table-column prop="date" label="图片" width="84">
        <template slot-scope="scope">
          <el-image
            style="width: 64px; height: 64px"
            :src="scope.row.FStockImagePath"
            :preview-src-list="[scope.row.FStockImagePath]"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline" />
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="商品" width="350">
        <template slot-scope="scope">
          <div class="goodsName"><span
            @click="toDetail(scope.row,item)"
          >{{ scope.row.FStockName }}</span></div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="单价/数量" width="180">
        <template slot-scope="scope">
          <div v-if="FPriceShow">
            <span class="price" v-html="splitPrice(scope.row.FTotalPrice)" />
            <span style="margin:0 5px;">
              X
            </span>
            <span>
              {{ scope.row.FQuanty }}
              <span v-if="scope.row.FMeasurement">{{ scope.row.FMeasurement }}</span>
            </span>
          </div>
          <div v-else id="noShowPrice">
            <span>￥</span>价格不可见
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="onTapToService(scope.row)">申请售后</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import request from '@/utils/request.js'
export default {
  filters: {

  },
  props: {
    afterSalesVisible: {
      type: Boolean
    },
    afterList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      fPriceShow: 0,
      tableData: []
    }
  },
  watch: {

  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
  },
  methods: {
    splitPrice(val) {
      const str = val ? val.toFixed(2) : '0.00'
      return `￥<span style="font-size:16px;">${str.split('.')[0]}</span>.${str.split('.')[1]}`
    },
    handleClose() {
      this.$emit('closeTips', false)
    },
    confirm() {
      //   this.$emit('cfmTips', this.tipType)
    },
    onTapToService(row) {
      this.$parent.onTapToService(row)
    }
  }
}
</script>

<style lang='scss'>
    .afterSales {
        .el-dialog {
            border-radius: 6px;

            .el-dialog__header {
                height: 66px;
                position: relative;
                width: 765px;
                margin: auto;
                background-color: #fff;
                border-radius: 6px 6px 0 0;

                .el-dialog__title {
                    height: 26px;
                    line-height: 26px;
                    position: absolute;
                    bottom: 0;
                    font-size: 20px;
                    color: #333;
                    font-weight: bold;
                }

                .el-dialog__headerbtn {
                    top: 24px;
                    right: 0px;
                }

                .el-icon-close {
                    color: #C0C5CF;
                }
            }

            .el-dialog__body {
                padding: 30px 48px;

                .el-table__header-wrapper {
                    display: none;
                }

                .el-table__body-wrapper {
                    max-height: 450px;
                    overflow-y: auto;
                    margin-top: 22px;

                    .cell {
                        height: 64px;
                        .price {
                            color: #EC212D;
                            font-weight: bold;
                        }
                        .el-button {
                            width: 84px;
                            background: #FFFFFF;
                            border-radius: 0;
                            border-color: #EC212D;
                            color: #EC212D;
                        }
                    }
                    .goodsName {
                        text-align: left;
                        height: 47px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                    #noShowPrice {
                        height: 26px;
                        line-height: 26px;
                        padding: 0 5px;
                        font-size: 14px;
                        color: #ec2631;
                        //   background: #fbd3d5;
                        width: 100px;
                        margin: 0 auto;

                        span {
                            font-size: 12px;
                        }
                    }
                }
            }

            .el-dialog__footer {
                padding: 10px 20px;
            }
        }
    }
</style>
